export const MonitoringReport = {
	list_legacy: function() {

    var options = {
      bDestroy: true,
      bDeferRender: true,
      data: JSON.parse(jQuery('#list-data').html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      drawCallback: function () {
        DataTablesHelper.addColumnFilters(this);
        ActionJS.MonitoringReport.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      },
      pageLength: 20,
      autoWidth: false,
      columnDefs: [
        {
          targets: [-1],
          searchable: false,
          sortable: false
        },
        {
          targets: [0],
          render: function(data, type, full, meta){
            if (type == 'display'){
              return jQuery('#report-name-template').html().replace('__id__', data.id).replace('__name__', data.name);
            }else{
              return data.name;
            }
          }
        },
        {
          targets: [1],
          render: function(data, type, full, meta){
            if (type == 'display'){
              return data.label;
            }
            return data.value
          }
        }
      ],
    };

    var formTable = jQuery('#monitoring-report-table');
    formTable.DataTable(options);
  },
  
  _form: function() {
    jQuery('.select2').select2();
    $('.smartme-toggle').smartmeToggle();
    
    jQuery('#monitoring_report_calls').on('change', function() {
      var projectCalls = jQuery(this).data('project-calls');
      jQuery('#monitoring_report_projects').val([]);
      (jQuery(this).val() || []).forEach(function(v) {
        (projectCalls[v] || []).forEach(function(id) {
          var ids = jQuery('#monitoring_report_projects').val() || [];
          ids.push(id);
          jQuery('#monitoring_report_projects').val(ids);
        });
      });

      jQuery('#monitoring_report_projects').trigger('change');
    });
  },

  project_reports: function() {
    var content = jQuery(".main .project-reports-container");
    content.css("height", "calc(100vh - " + content.position().top + "px)");
  },
  
  priv: {
    bindEvent: function(){
      jQuery('.form-clone-link, .form-delete-link').off('click').on('click', function(e){
        e.stopPropagation();
        var c = true;
        if (jQuery(this).data('confirm')){
          c = confirm(jQuery(this).data('confirm'));
        } 
        if (c) {
          jQuery.ajax({
            url: jQuery(this).attr('href'),
            method: 'POST',
            headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
          }).done(function(d){
            Turbo.visit(location.href, {action: 'replace'});
          });
        }
        e.preventDefault();
      });
    }
  }
};